<template>
  <p ref="paragraph" class="text"></p>
</template>

<script>
export default {
  name: 'BaseText',
  props: {
    text: {
      required: true,
      type: [String, Number]
    }
  },
  mounted() {
    this.$refs.paragraph.innerHTML = this.text
  }
}
</script>

<style lang="scss">
.text {
  font-family: $ToyotaBook;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #595d60;
}

@include media-min($tablet-width) {
  .text {
    font-size: 12px;
    line-height: 1.5;
  }
}

@include media-min($desktop-width) {
  .text {
    font-size: 16px;
    line-height: 1.6;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseText.vue